const axios = require('axios');
import * as odpUtils from '../integrations/ODP/utils';

class FilterOption {
    constructor() {
        this.PageValue = 1;
        this.PageSize = 20;
        this.Sort = "Relevance";
    }
}

function searchTrigger() {
    // for filtering
    let PageClass = "jsPaginate";
    let SortClass = "jsSort";
    let PageSizeClass = "jsPageSize";
    let FacetClass = "jsFacet";
    let Params = "";
    let RootUrl = window.location.href.substr(0, window.location.href.indexOf('?'));
    // to get information page
    let Page = ".jsPageInfo";
    let PageSize = ".jsPageSizeInfo";
    let Sort = ".jsSortInfo";
    let SortText = ".jsSortText";
    let ViewMode = ".jsViewModeInfo";

    //// Search, Filter handler
    function paginate(page) {
        $(Page).val(page);
        search();
    }

    function removeTag(inputName) {
        $(`input[name='${inputName}']`).prop('checked', false);
        search();
    }

    function removeAllTag() {
        $('.jsSearchFacet').each(function () {
            if ($(this).prop("checked") === true) {
                $(this).prop("checked", false);
            }
        });

        search();
    }

    function sort(sortBy) {
        $(Sort).val(sortBy);
        search();
    }

    function getFilter() {
        var q = new FilterOption();
        q.PageValue = $(Page).val();
        q.PageSize = $(PageSize).val();
        q.Sort = $(Sort).val();

        Params = getUrlWithFacets();

        return q;
    }

    function search() {
        var data = getFilter();
        $('.loading-box').show();
        axios({ url: RootUrl + Params, params: { data }, method: 'get' })
         .then(function (result) {
             window.history.replaceState(null, null, Params == "" ? "?" : Params);
             $(".resources-count").replaceWith($(result.data).find('.resources-count'));
             $(".product-count").replaceWith($(result.data).find('.product-count'));
             $('.loadmore-content').replaceWith($(result.data).find('.loadmore-content'));
             $('.loadmore-products').replaceWith($(result.data).find('.loadmore-products'));
             $('.jsContentResults').replaceWith($(result.data).find('.jsContentResults'));
             $('.jsProducts').replaceWith($(result.data).find('.jsProducts'));
             $('.selected-facets').replaceWith($(result.data).find('.selected-facets'));

             $('#total-filter-count').replaceWith($(result.data).find('#total-filter-count'));
             $('.filter-count').replaceWith($(result.data).find('.filter-count'));
             $('.mobile-filter-menu-trigger .total-results').html($(result.data).find('.mobile-filter-menu-trigger .total-results').html());
             $('.mobile-filter-menu-trigger .total-results-products').html($(result.data).find('.mobile-filter-menu-trigger .total-results-products').html());
             $('.collections-accordion__items-checked').each(function (idx, item) {
                 $(item).html($(result.data).find('.collections-accordion__items-checked').eq(idx).html());
             });
             $('.result-count .content-count-value').html($(result.data).find('.result-count .content-count-value').html());
             $('.result-count .product-count-value').html($(result.data).find('.result-count .product-count-value').html());

             //product results GTM datalayer push
             var gtmDataLayerProductResults = $(result.data).filter('script.impressions-productresults');
             if (gtmDataLayerProductResults != null && gtmDataLayerProductResults.length > 0) {
                 $('head').append('<script>' + gtmDataLayerProductResults.html() + '<\/script>');
             }

             //resources GTM datalayer push
             var gtmDataLayerResources = $(result.data).filter('script.impressions-resources');
             if (gtmDataLayerResources != null && gtmDataLayerResources.length > 0) {
                 $('head').append('<script>' + gtmDataLayerResources.html() + '<\/script>');
             }

             // save the current tab(prodcut-items or content-items)
             localStorage.setItem("SelectedTab", $(".collections-tabs .collections-tabs__items.active").attr('data-id'));
             location.reload();
             Init();
         })
         .catch(function (error) {
             
         })
         .finally(function () {
             $('.loading-box').hide();
         });
    }

    function getUrlWithFacets() {
        var facets = [];
        $('.jsSearchFacet').each(function () {
            if ($(this).prop("checked") === true) {
                var selectedFacet = encodeURIComponent($(this).data('facetkey'));
                if ($.inArray(selectedFacet, facets) < 0) {
                    facets.push(selectedFacet);
                }
            }
        });
        var sort = $(Sort).val();
        var pageValue = $(Page).val();
        var pageSize = $(PageSize).val();

        return getUrl(facets, sort, pageValue, pageSize);
    }

    function getUrl(t, sort, pageValue, pageSize) {
        var urlParams = getUrlParams();
        urlParams.t = t ? t.join('|') : null;
        urlParams.sort = sort;
        urlParams.pageValue = pageValue;
        urlParams.pageSize = pageSize;
        var url = "?";
        for (var key in urlParams) {
            var value = urlParams[key];
            if (value) {
                url += key + '=' + value + '&';
            }
        }
        return url.slice(0, -1); //remove last char
    }

    function getUrlParams() {
        var match,
            search = /([^&=]+)=?([^&]*)/g, //regex to find key value pairs in querystring
            query = window.location.search.substring(1);

        var urlParams = {};
        match = search.exec(query);
        while (match) {
            urlParams[match[1]] = match[2];
            match = search.exec(query);
        }

        return urlParams;
    }
    
    function facetEventBind() {
        $('.jsSearchFacetMobileRemoveAll').click(function () {
            removeAllTag();
        });

        $('.jsUpdatePage').each(function (i, e) {
            $(e).click(function (event) {
                var data = $(this).attr('data');

                if ($(this).hasClass(SortClass)) {
                    console.log("inside sorting");
                    odpUtils.TrackSearchSorting();
                    sort(data);
                }

                if ($(this).hasClass(FacetClass)) {
                    event.preventDefault();
                    console.log("inside filter");
                    odpUtils.TrackSearchFilter();
                    var forName = $(this).attr('for');
                    $('.jsSearchFacet:checkbox').each(function (i, el) {
                        if ($(el).attr('id') === forName) {
                            if ($(el).prop("checked") === false) {
                                $(el).prop("checked", true);
                            }
                            else {
                                $(el).prop("checked", false);
                            }
                        }
                    });
                    search();
                }

            });
        });

    }

    function Init() {
        $('.collections-tabs__items').click(function () {
            var dataId = $(this).attr('data-id');
            $('.mobile-filter-menu-trigger .total-results-products').addClass('d-none');
            $('.mobile-filter-menu-trigger .total-results').addClass('d-none');
            $('#' + dataId).removeClass('d-none');

            $('.content-count-value').addClass('d-none');
            $('.product-count-value').addClass('d-none');
            $(".result-count span[data-count=" + dataId + "]").removeClass('d-none');
        });

        $('.jsSearchFacetRemoveAll').click(function () {
            removeAllTag();
        });

        $('.jsRemoveTag').each(function (i, e) {
            $(e).click(function () {
                var name = $(this).attr('data-refinementvalue');
                removeTag(name);
            });
        });

        $('.jsUpdatePage').each(function (i, e) {
            $(e).click(function () {
                var data = $(this).attr('data');
                if ($(this).hasClass(PageClass)) {
                    paginate(data);
                }
            });
        });

        $('.jsGtmClick').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                var gtmData = $(this).data('gtmclick');
                if (gtmData !== null && typeof (window.dataLayer) != 'undefined' && window.dataLayer !== null) {
                    window.dataLayer.push(gtmData);
                }

                window.location.href = $(this).attr('href');
            });
        });


        $('.jsConfigureProduct').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                var gtmData = $(this).data('gtmclick');
                if (gtmData !== null && typeof (window.dataLayer) != 'undefined' && window.dataLayer !== null) {
                    window.dataLayer.push(gtmData);
                }

                window.location.href = $(this).data('url');
            });
        });

        $('.jsConfigureBundle').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                window.location.href = $(this).data('url');
            });
        });
    
        ////-- end
    }

    Init();
    facetEventBind();
}

searchTrigger();